import React from "react";
import Indusone from "../../images/bg-image/IMG_0094 (1).jpeg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-2">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4 text-center">
            Aircraft Maintenance Sealant (RTV)
            </h2>
            <p className="text-sm md:text-lg mb-6 text-justify md:mt-1">
            When it comes to assembling, sealing and protecting critical components in the air or in space, why leave anything to chance? Having developed silicone materials used on every manned US space flight, including the material used to produce the sole of the boot that first imprinted the moon, Momentive sets the standard of excellence in aerospace and aviation silicone technologies. We are proud of our long standing relationships and contributions to the successes of the world’s venture into outer space. 

            
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;

